import { Props } from "chakra-react-select";
import { UseControllerProps, FieldError } from "react-hook-form";

export type ControlledSelectProps = UseControllerProps & Props & { onError?: (error: FieldError) => void };

export interface OptionType<T = unknown> {
  label: string | number | undefined;
  value: string | number | undefined;
  rawValue?: T;
  __isNew__?: string;
}

export const MENU_PORTAL_Z_INDEX = 9999;
